/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Model_DescriptionInputs */



/**
* | output |
* | --- |
* | "Leave on the organization default unless this agent needs a specific model." |
*
* @param {Agent_Builder_Model_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_model_description = /** @type {((inputs?: Agent_Builder_Model_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Model_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Belassen Sie es beim Standard der Organisation, sofern dieser Agent kein bestimmtes Modell benötigt.")
	return /** @type {LocalizedString} */ ("Leave on the organization default unless this agent needs a specific model.")
});